import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'

export const TIME_STEP = 30

export const DAYS_OF_WEEK = {
	mon: 'Lundi',
	tue: 'Mardi',
	wed: 'Mercredi',
	thu: 'Jeudi',
	fri: 'Vendredi',
	sat: 'Samedi',
	sun: 'Dimanche',
}

export type DayKey = keyof typeof DAYS_OF_WEEK

export const TIMEZONES = [
	'UTC',
	'America/New_York',
	'America/Chicago',
	'America/Denver',
	'America/Los_Angeles',
	'Europe/London',
	'Europe/Paris',
	'Europe/Berlin',
	'Asia/Tokyo',
	'Asia/Shanghai',
	'Asia/Kolkata',
	'Australia/Sydney',
]

export const TIMES = Array.from({ length: 24 * 4 }, (_, i) => {
	const minutes = i * 15
	const hours = Math.floor(minutes / 60)
	const mins = minutes % 60
	return dateTimeUtils().hour(hours).minute(mins).format('HH:mm')
})
